export default "__VITE_ASSET__DsmQrA1l__"